import React, { useEffect, useState } from 'react'
import './SalaryCalculator.css'

const SalaryCalculator = () => {
    const [totalCTC, setTotalCTC] = useState('');
    const [monthlySalary, setMonthlySalary] = useState('');
    const handleInputChange = (e) => {
        let value = e.target.value;
        value = value.replace(/[^0-9]/g, '');
        setTotalCTC(Number(value).toLocaleString());
    };
    const calculateSalary = () => {
        let numericCTC = totalCTC.replace(/,/g, '');
        numericCTC = parseFloat(numericCTC);
        let salary = numericCTC/12;
        if(numericCTC > 1275000){
            let remainingTaxableSalary = numericCTC - 75000;
            let totalTax = 0;

            if(remainingTaxableSalary > 2400000){
                const taxable30 = remainingTaxableSalary - 2400000;
                const tax30 = (taxable30 * 30) / 100;
                totalTax = totalTax + tax30;
                remainingTaxableSalary = remainingTaxableSalary - taxable30;
            }
            if(remainingTaxableSalary > 2000000){
                const taxable25 = remainingTaxableSalary - 2000000;
                const tax25 = (taxable25 * 25) / 100;
                totalTax = totalTax + tax25;
                remainingTaxableSalary = remainingTaxableSalary - taxable25;
            }
            if(remainingTaxableSalary > 1600000){
                const taxable20 = remainingTaxableSalary - 1600000;
                const tax20 = (taxable20 * 20) / 100;
                totalTax = totalTax + tax20;
                remainingTaxableSalary = remainingTaxableSalary - taxable20;
            }
            if(remainingTaxableSalary > 1200000){
                const taxable15 = remainingTaxableSalary - 1200000;
                const tax15 = (taxable15 * 15) / 100;
                totalTax = totalTax + tax15;
                remainingTaxableSalary = remainingTaxableSalary - taxable15;
            }
            if(remainingTaxableSalary > 800000){
                const taxable10 = remainingTaxableSalary - 800000;
                const tax10 = (taxable10 * 10) / 100;
                totalTax = totalTax + tax10;
                remainingTaxableSalary = remainingTaxableSalary - taxable10;
            }
            if(remainingTaxableSalary > 400000){
                const taxable5 = remainingTaxableSalary - 400000;
                const tax5 = (taxable5 * 5) / 100;
                totalTax = totalTax + tax5;
                remainingTaxableSalary = remainingTaxableSalary - taxable5;
            }

            console.log("total tax : " + totalTax);

            const salaryAfterTax = numericCTC - (totalTax + ((totalTax*4)/100)) - 45600; // 21600+21600 pf, 2400 prof tax
            console.log("total tax : " + (totalTax + ((totalTax*4)/100)) )
            salary = salaryAfterTax/12;
            console.log("salary : " + salary);
        }else{
            salary = numericCTC - 45600;
            salary = salary/12;
        }
        let formattedSalary;
        if (salary % 1 === 0) {
            formattedSalary = salary.toLocaleString();
        } else {
            formattedSalary = parseFloat(salary.toFixed(2)).toLocaleString();
        }
        setMonthlySalary(formattedSalary);
    }
    useEffect(() => {
        if (totalCTC) {
            calculateSalary();
        }
    }, [totalCTC]);

    const getSalaryColorClass = (salary) => {
        if (salary < 50000) return 'red';
        if (salary >= 50000 && salary <= 100000) return 'white';
        return 'green';
    };

  return (
    <div>
    <div className='main-salary-container'>
        <div className='salary-container'>
            <h1 className='head-salary'>monthly salary calculator!</h1>
            <div className='add-salary'>
                <p>Your Fixed CTC?</p>
                <input className='ip' type='text' value={totalCTC} onChange={handleInputChange} placeholder="Fixed CTC"/>
            </div>
            <h3 className='salary-result'>your monthly in hand salary after tax and pf deduction :  
                <span className={`monthly-salary ${getSalaryColorClass(parseFloat(monthlySalary.replace(/,/g, '')) || 0)}`}>
                    {monthlySalary}
                </span>
            </h3>
        </div>
    </div>
    </div>
  )
}

export default SalaryCalculator
